export const SET_PAGE_SIZE = 'SET_PAGE_SIZE'
export const SET_SEARCH_TERM = 'SET_SEARCH_TERM'
export const SET_SORT_DIR = 'SET_SORT_DIR'
export const SET_ORDER_BY = 'SET_ORDER_BY'
export const SET_FILTER_OPTIONS = 'SET_FILTER_OPTIONS'
export const SET_FILTER_BY = 'SET_FILTER_BY'
export const SET_RETRO_DAY = 'SET_RETRO_DAY'
export const SET_STATUS = 'SET_STATUS'
export const REQUEST_SEARCH_TERM = 'REQUEST_SEARCH_TERM'
export const REQUEST_PAGE_SIZE = 'REQUEST_PAGE_SIZE'
export const REQUEST_SORT_DIR = 'REQUEST_SORT_DIR'
export const REQUEST_ORDER_BY = 'REQUEST_ORDER_BY'
export const REQUEST_FILTER_BY = 'REQUEST_FILTER_BY'
export const REQUEST_RETRO_DAY = 'REQUEST_RETRO_DAY'
export const REQUEST_STATUS = 'REQUEST_STATUS'
export const REFRESH_REQUEST = 'REFRESH_REQUEST'
export const RESET_REQUESTS = 'RESET_REQUESTS'
export const SET_REQUESTS = 'SET_REQUESTS'
export const SET_REQUEST = 'SET_REQUEST'
export const SET_NEW_REQUEST = 'SET_NEW_REQUEST'
export const SET_VEHICLEINFO = 'SET_VEHICLEINFO'
export const SET_VEHICLE = 'SET_VEHICLE'
export const SET_REQUESTCOUNTS = 'SET_REQUESTCOUNTS'
export const SET_VIN_SUMMARY = 'SET_VIN_SUMMARY'
export const SET_VIN_SUMMARY_UK = 'SET_VIN_SUMMARY_UK'
export const SET_YEARS = 'SET_YEARS'
export const SET_MAKES = 'SET_MAKES'
export const SET_MODELS = 'SET_MODELS'
export const SET_SUBMODELS = 'SET_SUBMODELS'
export const SET_ENGINES = 'SET_ENGINES'
export const SET_TRANSMISSIONS = 'SET_TRANSMISSIONS'
export const SET_DRIVETYPES = 'SET_DRIVETYPES'
export const SET_SCANTYPES = 'SET_SCANTYPES'
export const SET_REQUESTID = 'SET_REQUESTID'
export const SET_STATUSLIST = 'SET_STATUSLIST'
export const UPDATE_REQUEST_RECORD = 'UPDATE_REQUEST_RECORD'
export const UPDATE_TOTAL_UNREAD = 'UPDATE_TOTAL_UNREAD'
export const UPDATE_UNREAD = 'UPDATE_UNREAD'
export const RESET_REQUEST_UNREAD = 'RESET_REQUEST_UNREAD'
export const UPDATE_REQUEST_UNREAD = 'UPDATE_REQUEST_UNREAD'
export const SET_REQUEST_HISTORY = 'SET_REQUEST_HISTORY'
export const SESSION_SCANTYPES = 'servicerequests/scantypes'
export const SET_REQUEST_NOTES = 'SET_REQUEST_NOTES'
export const SET_STATE_DEFAULT = 'SET_STATE_DEFAULT'
export const SET_STATE_ASSEMBLY = 'SET_STATE_ASSEMBLY'
export const SET_STATE_SRS = 'SET_STATE_SRS'
export const SET_STATE_LIGHTS = 'SET_STATE_LIGHTS'
export const SET_STATE_KEY_ENGINE = 'SET_STATE_KEY_ENGINE'
export const SET_STATE_DAMAGE_LEVEL = 'SET_STATE_DAMAGE_LEVEL'
export const SET_STATE_DAMAGE_POSITION = 'SET_STATE_DAMAGE_POSITION'
export const UPDATE_SCAN_REPORT = 'UPDATE_SCAN_REPORT'
export const UPDATE_SCAN_REPORT_FOLLOW_UP = 'UPDATE_SCAN_REPORT_FOLLOW_UP'
export const UPDATE_SCAN_REPORT_PERFORMED_PROGRAMMING = 'UPDATE_SCAN_REPORT_PERFORMED_PROGRAMMING'
export const SET_SHOP_DEVICE = 'SET_SHOP_DEVICE'
export const SET_REQUESTSTATUS = 'SET_REQUESTSTATUS'
export const UPDATE_DEVICE = 'UPDATE_DEVICE'
export const SET_REQUEST_SCAN_TYPE = 'SET_REQUEST_SCAN_TYPE'
export const SET_CALIBRATE_CONFIG = 'SET_CALIBRATE_CONFIG'
export const UPDATE_CALIBRATE_CONFIG = 'UPDATE_CALIBRATE_CONFIG'
export const UPDATE_CALIBRATION_COMPLETE = 'UPDATE_CALIBRATION_COMPLETE'
export const SET_SYNC_COLUMNS = 'SET_SYNC_COLUMNS'
export const SYNC_COLUMNS = 'SYNC_COLUMNS'



// WEBPACK FOOTER //
// ./src/store/modules/servicerequests/types.js